<app-header
  [operationMode]="operationMode"
  [subRoute]="step"
  [alertSuccessMessage]="alertSuccessMessage"
  [showSuccessAlert]="showSuccessMessage"
  [showQuestionTypeBtn]="showCreateButton"
  [suppressAnnouncement]="suppressAnnouncement"
  (itemInfoDataEmitter)="getItemData($event)"
  (settingsRouteActivate)="settingsRouteActivate()"
  (filterEvent)="filterEvent($event)"
  (closeAlert)="closeAlert()"
  (focusCreateQuestion)="focusCreateQuestion()"
  [inputPlaceholder]="'Enter Test Title'"
></app-header>
<h1 #step1Heading class="sr-only" *ngIf="step !== 'step2'">Create/Edit Assessment</h1>
<div class="assesment-examstatstic-modal">
  <!-- basic modal -->
  <app-shared-modal
    titleText="Test Statistics"
    [isOpen]="examStatisticsModalIsVisible"
    confirmButtonText="OK"
    (show)="examStatisticsModalIsVisible = true"
    (close)="closeExamStatistics()"
    (cancel)="closeExamStatistics()"
    (confirm)="examStatisticsConfirm()"
  >
    <div class="row">
      <p>This test is distributed based on the selected question attributes.</p>
    </div>
    <div class="row bottom-20">
      <strong>Total Questions:</strong
      ><span class="question-count-span">{{ totalQuestionCount }}</span>
    </div>
    <div
      class="row"
      *ngIf="
        examStatsticsList != undefined &&
        examStatsticsList.hasOwnProperty('Chapter')
      "
    >
      <h3 class="section-heading">Chapter:</h3>
      <table class="table table-hover testTable">
        <thead>
          <tr>
            <th scope="col">Chapter Reference</th>
            <th scope="col" class="text-right">Count</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let chaptName of examStatsticsList.Chapter | keyvalue">
            <td>{{ chaptName.key }}</td>
            <td class="text-right">{{ chaptName.value }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="row"
      *ngIf="
        examStatsticsList != undefined &&
        examStatsticsList.hasOwnProperty('Question_Types')
      "
    >
      <h3 class="section-heading">Question Type:</h3>
      <table class="table table-hover testTable">
        <thead>
          <tr>
            <th scope="col">Question Type</th>
            <th scope="col" class="text-right">Count</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let questType of examStatsticsList['Question_Types'] | keyvalue
            "
          >
            <td>{{ questType.key }}</td>
            <td class="text-right">{{ questType.value }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="row"
      *ngIf="
        examStatsticsList != undefined &&
        examStatsticsList.hasOwnProperty('category') &&
        examStatsticsList.category.hasOwnProperty('Difficulty')
      "
    >
      <h3 class="section-heading">Difficulty:</h3>
      <table class="table table-hover testTable">
        <thead>
          <tr>
            <th scope="col">Difficulty</th>
            <th scope="col" class="text-right">Count</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let examDifficulty of examStatsticsList.category.Difficulty
                | keyvalue
            "
          >
            <td>{{ examDifficulty.key }}</td>
            <td class="text-right">{{ examDifficulty.value }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      class="row"
      *ngIf="
        examStatsticsList != undefined &&
        examStatsticsList.hasOwnProperty('category') &&
        examStatsticsList.category.hasOwnProperty('Learning_Objective')
      "
    >
      <h3 class="section-heading">Learning Objectives:</h3>
      <table class="table table-hover testTable">
        <thead>
          <tr>
            <th scope="col">Learning Objectives</th>
            <th scope="col" class="text-right">Count</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="
              let learningObjective of examStatsticsList.category[
                'Learning_Objective'
              ] | keyvalue
            "
          >
            <td>{{ learningObjective.key }}</td>
            <td class="text-right">{{ learningObjective.value }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </app-shared-modal>
</div>
<div class="assesment-updatepoints-modal">
  <app-shared-modal
    titleText="Update Points"
    [isOpen]="modalIsVisible"
    confirmButtonText="Update"
    [disableConfirm]="updatePointsValidationObject.isDisableUpdatePoints"
    (show)="modalIsVisible = true"
    (close)="closeUpdateBulkPointsModal()"
    (cancel)="closeUpdateBulkPointsModal()"
    (confirm)="updateBulkPoints()"
  >
    <div>
      Update the selected questions' point values.
      <strong>{{ bulkUpdatePointsSelectedQuestionCount }}</strong>
      questions will be affected
    </div>
    <div class="col-md-3 col-lg-3 pl-0">
      <label for="updatePointsInput">Replace point value: <small class="required">(required)</small></label>
    </div>
    <div class="col-md-5 col-lg-5 pl-0">
      <app-input
        #updatePointsInput
        [id]="'updatePointsInput'"
        class="updatePointsInputStyle"
        [value]="bulkUpdatePointInputValue"
        [error]="updatePointsValidationObject.showInvalidMessage !== ''"
        [info]="modalIsVisible"
        [feedback]="['Enter a point value between 0.00 and 1000.00']"
        [visualOnlyFeedback]="true"
        [(ngModel)]="bulkUpdatePointInputValue"
        (inputChange)="onChange($event)"
        (focusout)="validatePoints($event)"
        maxlength="7"
        [required]="true"
      ></app-input>
      <div
        class="sr-only"
        role="alert">
        {{ updatePointsValidationObject.errorMessageAnnouncement }}
      </div>
    </div>
  </app-shared-modal>
</div>
<app-filter-test-category
  *ngIf="bankObj.questions"
  [question-list]="bankObj.questions"
  (messageEvent)="receiveMessage($event)"
  (filterEvent)="receiveFilter($event)"
  (countChangeEvent)="handleCountChange($event)"
>
</app-filter-test-category>
<div class="row row1 tab-width m-0" *ngIf="showSettings">
  <div class="col-12 col-md-9 col-lg-9 mt-5 ml-lg-5 margin-right-settings d-flex d-lg-block justify-content-center justify-content-lg-start">
    <app-tabs
      [hidden]="!showSettings"
      [tabIndex]="tabIndex"
      (tabClick)="tabClick($event)"
      [showSteps]="true"
      class="w-95"
    >
      <app-tab name="Content"></app-tab>
      <app-tab
        *ngIf="
          selectedQuestionsListObj != undefined &&
          selectedQuestionsListObj.length > 0
        "
        name="Settings"
        (click)="step = 'step2'"
      ></app-tab>
      <app-tab
        *ngIf="
          selectedQuestionsListObj === undefined ||
          selectedQuestionsListObj.length == 0
        "
        name="Settings"
        [disabled]="true"
      ></app-tab>
    </app-tabs>
  </div>
</div>
<div
  *ngIf="step === 'step1'"
  class="container-fluid container-height-calc"
  #sourceContainer
>
  <div class="container-fluid padding-head height-100">
    <div class="row height-100 main-content">
      <!-- left panel -->
      <div
        [hidden]="panelExpandedRight"
        id="left-panel"
        class="height-100"
        [ngClass]="panelExpanded ? 'col-12' : 'col-12 p-0 px-sm-4 split-panel'"
      >
        <div class="container-fluid p-0 m-0 row-head height-100">
          <div class="row head padding-right-10 m-0 pl-2" #leftPanelHeader>
            <div class="center-align pl-3 pl-lg-4">
              <div *ngIf="hideHeader" class="add-from-header">
                <h2 id="add-from-title" class="panel-title d-inline">Add From 
                  <span
                    [innerHtml]="bankObj?.bank?.title | truncate : [titleTruncateLength, '...']"
                    [title]="bankObj?.bank?.title"
                    aria-hidden="true"
                  ></span>
                  <span class="sr-only">{{ bankObj?.bank?.title }}</span>
                </h2>
              </div>
              <div id="add-question-header" [hidden]="hideHeader"><h2 class="panel-title">Add Question</h2></div>
            </div>
            <div class="text-right btn-change ml-auto d-flex align-items-center">
              <div class="change-source-div">
                <app-button
                  #changeSourceButton
                  buttonText="Change Source"
                  class="btn-sm pl-0 h-auto change-source-button"
                  [enableLight]="true"
                  [purpose]="_buttonPurpose.Secondary + 'position-static'"
                  [disabled]="false"
                  *ngIf="hideHeader"
                  (click)="changeSourcePicker()"
                ></app-button>
              </div>
              <div class="fullscreen-toggle px-3" role="button" tabindex="0" [attr.aria-label]="panelExpanded ? 'Exit Full Screen Mode for ' + (hideHeader ? 'Add From' : 'Add Question') : 'Enter Full Screen Mode for ' + (hideHeader ? 'Add From' : 'Add Question')"
                (click)="expandPanel('left')" (keydown.enter)="expandPanel('left')" (keydown.space)="expandPanel('left')"
                [appTooltip]="panelExpanded ? 'Exit Full Screen Mode' : 'Enter Full Screen Mode'"
                >
                <i
                  class="handPointer"
                  [ngClass]="
                    panelExpanded
                      ? 'dpg-icon dpg-icon-system-fullscreen-exit-white'
                      : 'dpg-icon dpg-icon-system-fullscreen-white'
                  "
                ></i>
              </div>
            </div>
          </div>
          <div
            *ngIf="!showBank"
            id="question-bank-header"
            class="row question-bank-header p-3 px-lg-4 m-0 flex-wrap flex-sm-nowrap align-items-center"
          >
            <div
              class="flex-grow-1"
            >
              <div class="ahe-ui form-group search-container" role="search" aria-label="Search Question in Add From Section">
                <app-input
                  #clearSearchInputLeft
                  [id]="'searchfilterLeft'"
                  [label]="'Search Source'"
                  [hideLabel]="true"
                  [placeholder]="'Search Source'"
                  [(ngModel)]="textSearchLeft"
                  [error]="false"
                  [icon]="'search'"
                  [value]="textSearchLeft"
                  [ariaDescribedBy]="'add-from-title'"
                >
                </app-input>
                <button
                    appTooltip="Clear Search"
                    *ngIf="textSearchLeft" 
                    id="clear-search-btn-left" 
                    class="clear-input" 
                    (click)="clearSearch()"
                    type="button"
                    aria-label="Clear Search"
                    [attr.aria-describedby]="'add-from-title'"
                  >
                  <span class="sr-only">Clear Search</span>
                  <i class="dpg-icon dpg-icon-system-close" aria-hidden="true"></i>
                </button>
              </div>
            </div>
            <div
              class="ml-4 mr-2 position-relative"
            >
              <button
                *ngIf="showFilterBtnTooltip"
                appTooltip="Filter"
                type="button"
                id="openMainPanel"
                class="btn btn-secondary btn-block filter-btn"
                (click)="OpenPanel('mainPanel', 0, '', $event, [])"
                aria-haspopup="dialog"
                [attr.aria-label]="count > 0 ? 'Filter, ' + count + ' applied' : 'Filter'"
              >
                Filter
              </button>
              <button
                *ngIf="!showFilterBtnTooltip"
                type="button"
                id="openMainPanel"
                class="btn btn-secondary btn-block filter-btn"
                (click)="OpenPanel('mainPanel', 0, '', $event, [])"
                aria-haspopup="dialog"
                [attr.aria-label]="count > 0 ? 'Filter, ' + count + ' applied' : 'Filter'"
              >
                Filter
              </button>
              <div *ngIf="!showBank" id="add-filter" aria-hidden="true">
                <div *ngIf="count > 0" class="count-show">
                  {{ count }}
                </div>
              </div>
            </div>
            <div
              class="add-to-test-wrapper ml-auto"
            >
              <div class="inline-block-element">
                <app-button
                  buttonText="Add To Test"
                  class="px-2"
                  [purpose]="_buttonPurpose.Primary"
                  [disabled]="enableAdd === 0"
                  (click)="addToRight($event)"
                ></app-button>
              </div>
              <div
                id="add-to-test-announcement"
                class="sr-only"
                aria-live="polite"
                aria-atomic="true"
              >
                {{ addToTestAnnouncement }}
              </div>
            </div>
          </div>
          <source-picker
            [addQuestionHeaderId]="'add-question-header'"
            (sourceSuccess)="checkQuestionLoad($event)"
            [truncate-Title]="truncateTitle"
            (questionFlagSelect)="hideAddQuestion($event)"
            (focusedElement)="setCurrentFocusElement($event)"
            (cancelButtonSelect)="hideLeftPanel($event)"
            *ngIf="showBank"
            [autoFocus]="shouldAutoFocusSourcePicker"
          ></source-picker>
          <div class="row m-0" *ngIf="bankObj.questions && !showBank">
            <source-bank
              class="width-100"
              [text-search]="textSearchLeft"
              [question-list]="bankObj.questions"
              [dropped-questions]="selectedQuestionsListObj"
              [panel-Expanded]="panelExpanded"
              [truncate-Title]="truncateTitle"
              (emitAddQuestion)="addQuestionClicked($event)"
              (singleItemClicked)="receiveDataPreviewClicked($event)"
              (enableAdd)="receiveDataWhileChecked($event)"
              [filters-list]="filterJsonObject"
              [filter-count]="finalFilterCount"
              (addToTestPanel)="addToRight(null, $event, true)"
              [isFilterPopupOpen]="child?.isFilterOpen"
              [filterAnnouncementRegion]="child?.filterAnnouncementRegion"
              (addToTestPanelTemp)="addToRightTemp($event)"
              (sourceDrag)="sourceDrag($event)"
            ></source-bank>
          </div>
        </div>
      </div>
      <preview-modal-component
        *ngIf="isPreviewSourceQuestions"
        [sourceLocationInfo]="'SourcePanel'"
        [preview-data]="previewSourceQuestionsList"
        [header]="previewHeaderText"
        [question-index]="questionIndex"
        (addQuestionClicked)="addQuestionClicked($event)"
        (closeModal)="closeModal($event)"
      >
      </preview-modal-component>
      <!-- right panel -->
      <div
        [hidden]="panelExpanded"
        id="right-panel"
        [ngClass]="panelExpandedRight ? 'col-12' : 'col-12 p-0 px-sm-4 split-panel'"
      >
        <div class="row row-head m-0" #dropZoneNoQuestion>
          <div class="col-12">
            <div
              class="row head center-align right-panel-container"
            >
              <div class="p-0 pl-sm-3">
                <h2 id="your-test-title" class="panel-title">Your Test</h2>
              </div>
              <div
                class="p-0 text-right question-type-container ml-auto"
              >
                <div
                  class="btn-change question-create"
                  id="questionTypeContainer"
                >
                  <app-question-type-dropdown
                    #createQuestionDropdown
                    [showQuestionTypes]="showQuestion"
                    [currentFocusedElement]="currentFocusedElement"
                    (emitValueOfDropdown)="updateChangeValueOfDropdown($event)"
                    (emitItemInfo)="getItemData($event)"
                    [menuWidth]="86"
                  ></app-question-type-dropdown>
                </div>
                <div class="p-0 right-expand-div text-right fullscreen-toggle" role="button" tabindex="0" [attr.aria-label]="panelExpandedRight ? 'Exit Full Screen Mode for Your Test' : 'Enter Full Screen Mode for Your Test'" (click)="expandPanel('right')" (keydown.enter)="expandPanel('right')" (keydown.space)="expandPanel('right')"
                [appTooltip]="panelExpandedRight ? 'Exit Full Screen Mode' : 'Enter Full Screen Mode'">
                  <i
                    class="handPointer"
                    [ngClass]="
                      panelExpandedRight
                        ? 'dpg-icon dpg-icon-system-fullscreen-exit-white'
                        : 'dpg-icon dpg-icon-system-fullscreen-white'
                    "
                  ></i>
                </div>
              </div>
            </div>
          </div>
          <div class="container-fluid">
            <div
              class="row question-bank-header p-2 p-sm-3 pl-lg-4 flex-nowrap align-items-center"
              *ngIf="selectedQuestionsListObj.length > 0 || tempAddedQuestion"     
            >
              <div
                class="flex-grow-1 ml-lg-2 mr-lg-3"
              >
                <div class="ahe-ui form-group search-container" role="search" aria-label="Search Question in Your Test Section">
                  <app-input
                    #clearSearchInputRight
                    [id]="'searchfilterRight'"
                    [label]="'Search Question'"
                    [hideLabel]="true"
                    [placeholder]="'Search Question'"
                    [(ngModel)]="searchedTextRight"
                    (ngModelChange)="dataChanged(true)"
                    [error]="false"
                    [icon]="'search'"
                    [value]="searchedTextRight"
                    [ariaDescribedBy]="'your-test-title'"
                  >
                  </app-input>
                  <button
                      appTooltip="Clear Search"
                      *ngIf="searchedTextRight" 
                      id="clear-search-btn-right" 
                      class="clear-input" 
                      (click)="clearSearchRight()"
                      type="button"
                      aria-label="Clear Search"
                      [attr.aria-describedby]="'your-test-title'"
                  >
                    <span class="sr-only">Clear Search</span>
                    <i class="dpg-icon dpg-icon-system-close" aria-hidden="true"></i>
                  </button>
                  <div 
                    id="search-results-status-right"
                    class="sr-only"
                    aria-live="polite"
                    aria-atomic="true">
                    {{ searchResultsAnnouncement }}
                  </div>
                </div>
              </div>
              <div>
                <app-button
                  [ariaHaspopup]="'dialog'"
                  class="pr-0 pl-2"
                  buttonText="Test Statistics"
                  [purpose]="_buttonPurpose.Secondary + ' px-2 px-sm-4'"
                  [disabled]="selectedQuestionsListObj.length == 0"
                  (click)="previeExamStatistics()"
                ></app-button>
              </div>
            </div>
            <div class="row">
              <div
                class="col-lg-12 col-md-12 col-xl-12 question-list-table"
                id="rightList"
                #dropZoneKeyboard
              >
                <div
                  *ngIf="selectedQuestionsListObj.length > 0 || tempAddedQuestion"
                  class="row row-head-right d-flex align-items-center pr-2 pl-sm-4"
                >
                  <div class="right-panel-select-checkbox ml-lg-1">
                    <app-checkbox
                      id="droppedCheckboxLabelId{{ selectedQuestions.index }}"
                      [checked]="selectedTitle.selected"
                      [disabled]="selectedQuestionsListObj.length == 0"
                      #selectAll
                      (change)="selectAllSelctedSource($event)"
                      value="Title"
                      name="title"
                      [ariaLabel]="'Select all questions for Your Test'"
                      [ariaChecked]="selectAllAriaCheckedRight"
                    >
                    </app-checkbox>
                  </div>
                  <div class="question-head pl-2 pl-sm-4">Question</div>
                  <div class="text-right pr-0 ml-auto">
                    <div class="d-flex align-items-center w-100 flex-wrap">
                      <app-button
                        *ngIf="!renameActivated && !mulQuestionActionKebabShow"
                        class="p-0 mr-3"
                        buttonText="Remove"
                        [purpose]="_buttonPurpose.Secondary"
                        (click)="removeSelected($event)"
                        [ariaHaspopup]="modalShow ? 'dialog' : null"
                      ></app-button>
                      <app-button
                        *ngIf="!renameActivated && !mulQuestionActionKebabShow"
                        class="p-0 mr-3"
                        buttonText="Update Points"
                        [purpose]="_buttonPurpose.Secondary"
                        (click)="updatePoints()"
                        [ariaHaspopup]="'dialog'"
                      ></app-button>
                      <app-button
                        class="p-0"
                        [class.pr-2]="renameActivated || !mulQuestionActionKebabShow"
                        [buttonText]="expandToggleText"
                        [disabled]="selectedQuestionsListObj.length == 0"
                        [purpose]="_buttonPurpose.Secondary"
                        (click)="expandAllToggle()"
                      ><span class="sr-only">For Your Test</span></app-button>
                      <kebab-component
                        *ngIf="!renameActivated && mulQuestionActionKebabShow"
                        class="ml-2"
                        [show_kebab]="mulQuestionActionKebabOptionShow"
                        [kebabMenuItems]="mulQuestionActionsMenu"
                        (updatePoints)="updatePoints()"
                        (removeQuestions)="removeSelected()"
                        (click)="mulQuestionActionKebabOptionShow = !mulQuestionActionKebabOptionShow"
                        (closeKebabOnEscape)="mulQuestionActionKebabOptionShow = false"
                        (clickOutside)="mulQuestionActionKebabOptionShow = false"
                        [alternateAriaLabel]="'More options for Your Test'"
                        [showRemoveModal]="modalShow"
                      ></kebab-component>
                    </div>
                  </div>
                </div>
                <div
                  class="row bodyRow"
                  id="test-panel"
                  #dropZoneWithQuestion
                  cdkDropList
                  [cdkDropListData]="selectedQuestionsListObj"
                  [cdkDropListConnectedTo]="['leftList']"
                  (cdkDropListDropped)="drop($event)"
                  (cdkDropListEntered)="onDragEnter($event)"
                  [cdkDropListSortPredicate]="sourceSelectSortPredicate"
                  [cdkDropListAutoScrollStep]="15" 
                  [style.height.px]="sourcePickerDestiHeight"
                >
                  <div
                    *ngIf="selectedQuestionsListObj.length > 0 || tempAddedQuestion"
                    style="width: 100%"
                  >
                    <div
                      class="container-fluid display-result padding-left-24"
                      *ngIf="searchedTextRight != ''"
                    >
                      <Strong
                        >Displaying {{ totalSearchCountRight }} results for "{{
                          searchedTextRight
                        }}"</Strong
                      >
                    </div>
                    <ul class="selected-questions-list">
                      <ng-container
                        *ngFor="
                          let selectedQuestions of currentData;
                          let i = index; last as last
                        "
                      >
                      <ng-container
                        *ngTemplateOutlet="QuestionBlock; context: { selectedQuestions: selectedQuestions, i: i, last: last, isTemporaryQuestion: false }"
                      >
                      </ng-container>
                    </ng-container>
                    @if (tempAddedQuestion) {
                      <div class="temp-added-question" #tempAddedQuestionContainer>
                        <ng-container
                          *ngTemplateOutlet="QuestionBlock; context: { selectedQuestions: tempAddedQuestion, i: 0, last: false, isTemporaryQuestion: true }"
                        >
                        </ng-container>
                      </div>
                    }
                    <ng-template #QuestionBlock let-selectedQuestions="selectedQuestions" let-i="i" let-last="last" let-isTemporaryQuestion="isTemporaryQuestion">
                       <li
                          class="container-fluid border-div list-unstyled"
                          [ngClass]="{'line-divider': i === 0}"
                          cdkDrag
                          [cdkDragData]="selectedQuestions"
                          (cdkDragStarted)="dragStarted()"
                          (cdkDragEnded)="removeDropZoneHighlight()"
                        >
                          <div class="row mr-0">
                          <div
                            id="droppedTablerowId{{ selectedQuestions.index }}"
                            class="p-all-0 col-1 select-div fixed-max-width-checkbox"
                            style="min-width: 64px;"
                          >
                            <div
                              class="qCheckboxHandler container-fluid h-100"
                              id="droppedCheckboxLabelId{{
                                selectedQuestions.index
                              }}"
                            >
                              <div class="row h-100">
                                <div
                                  class="col-auto mx-1 px-1 h-100 padding-top-74 drag-handle-div"
                                  [class.grabbed-state]="grabbedIndex === i || isTemporaryQuestion"
                                >
                                  <div role="button" tabindex="0" class="handles" cdkDragHandle #dragHandle
                                    [alternateAriaLabel]="'Move question handler for ' + selectedQuestions.title" appTooltip="Move question handler" (keydown)="dragHandlerKeydown($event, selectedQuestions, i, last)"
                                    (click)="dragHandleClicked(selectedQuestions, i)" [attr.aria-pressed]="grabbedIndex === i || isTemporaryQuestion" [attr.id]="'drag-handle-' + i"
                                    ><i
                                      *ngIf="selectedQuestions.pinned"
                                      class="fa fa-thumb-tack align-thumb"
                                      [class.text-white]="grabbedIndex === i || isTemporaryQuestion"
                                      aria-hidden="true"
                                    ></i
                                    ><i
                                      *ngIf="!selectedQuestions.pinned"
                                      id="droppedKebabId{{
                                        selectedQuestions.index
                                      }}"
                                      class="dpg-icon snowflakes-align"
                                      [ngClass]="{
                                        'dpg-icon-movingtile': (grabbedIndex !== i && !isTemporaryQuestion),
                                        'dpg-icon-movingtile-white': (grabbedIndex === i || isTemporaryQuestion)
                                      }"
                                    ></i>
                                    </div>
                                    <span class="sr-only" *ngIf="selectedQuestions.pinned">Pinned</span>
                                    <div class="sr-only" role="status">{{ grabbedIndex === i ? selectedQuestions.title + ' handler selected' : '' }}</div>
                                    <div class="sr-only" role="status">{{ deselectedIndex === i ? selectedQuestions.title + ' handler deselected' : '' }}</div>
                                  </div>
                                <div class="col-6 mx-0 p-0 left-draw">
                                  <app-checkbox
                                    #questionCheckbox
                                    class="left-checkbox"
                                    *ngIf="
                                      !isSectionBreak(selectedQuestions.refType)
                                    "
                                    id="droppedCheckboxLabelId{{
                                      selectedQuestions.index
                                    }}"
                                    class="select-checkbox"
                                    [ngClass]="
                                      !selectedQuestions.pinned
                                        ? 'select-checkbox'
                                        : 'select-checkbox'
                                    "
                                    [checked]="selectedQuestions.selected"
                                    value="selectedQuestions.qid"
                                    (change)="
                                      OnCheckboxSelect(
                                        selectedQuestions,
                                        $event,
                                        'scalar',
                                        false,
                                        '',
                                        ''
                                      )
                                    "
                                    [ariaLabel]="selectedQuestions.title"
                                  >
                                  </app-checkbox>
                                  <app-checkbox
                                    #questionCheckbox
                                    *ngIf="
                                      isSectionBreak(selectedQuestions.refType)
                                    "
                                    id="droppedCheckboxLabelId{{
                                      selectedQuestions.index
                                    }}"
                                    class="select-checkbox"
                                    [ngClass]="
                                      !selectedQuestions.pinned
                                        ? 'select-checkbox'
                                        : 'select-checkbox'
                                    "
                                    [checked]="selectedQuestions.selected"
                                    [ariaChecked]="selectedQuestions.ariaChecked || 'false'"
                                    value="selectedQuestions.qid"
                                    (change)="
                                      OnCheckboxSelect(
                                        selectedQuestions,
                                        $event,
                                        'multipart',
                                        false,
                                        '',
                                        ''
                                      )
                                    "
                                    [ariaLabel]="selectedQuestions.title"
                                  >
                                  </app-checkbox>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            class="col-md-11 col-lg-11 left-panel-div margin-7 display-text pl-0 pr-0 fixed-min-width-content"
                            title="{{ selectedQuestions.title }}"
                          >
                            <div class="row pl-4 mr-0">
                              <div class="title-div margin-top-7 question-type-container">
                                <span
                                  class="pill-btn height-20 btn-sm btn-primary"
                                >
                                  {{ selectedQuestions.typeDesc }}
                                </span>
                                <span
                                  *ngIf="selectedQuestions.algo"
                                  class="pill-btn height-20 btn-sm btn-primary"
                                >
                                  Algorithmic
                                </span>
                              </div>
                              <div class="mt-4 question-edit pl-4">
                                <span class="editQuestionsHandle">
                                  <i
                                    *ngIf="
                                      !isSectionBreak(
                                        selectedQuestions.refType
                                      ) && selectedQuestions.userEdited
                                    "
                                    id="droppedKebabId{{
                                      selectedQuestions.index
                                    }}"
                                    class="dpg-icon dpg-icon-more-practice"
                                    title="My Edited Question"
                                    aria-hidden="true"
                                  ></i>
                                  <i
                                    *ngIf="
                                      isSectionBreak(
                                        selectedQuestions.refType
                                      ) && selectedQuestions.edited == 1
                                    "
                                    id="droppedKebabId{{
                                      selectedQuestions.index
                                    }}"
                                    class="dpg-icon dpg-icon-more-practice"
                                    title="My Edited Question"
                                    aria-hidden="true"
                                  ></i>
                                    <span class="sr-only" *ngIf="isEditedQuestion(selectedQuestions)">Edited</span>
                                </span>
                              </div>
                              <div
                                id="droppedTablerowId{{
                                  selectedQuestions.index
                                }}"
                                class="p-all-0 question-margin kebab-wrapper"
                                [ngClass]="[
                                  noRightScalar(
                                    isSectionBreak(selectedQuestions.refType)
                                  )
                                ]"
                              >
                                <div
                                  id="droppedKebabId{{
                                    selectedQuestions.index
                                  }}"
                                  (click)="setKebabIndex(i)"
                                  *ngIf="
                                    !isSectionBreak(selectedQuestions.refType)
                                  "
                                >
                                  <kebab-component
                                    [collection]="selectedQuestions"
                                    [question-source]="true"
                                    [show_kebab]="i === kebabIndex"
                                    (pinUnpinQuestion)="
                                      pinUnpinQuestion($event)
                                    "
                                    [checked-questions]="sortedQuestionsList()"
                                    [disableDelete]="true"
                                    [kebabMenuItems]="kebabMenu"
                                    [last_kebab]="last"
                                    [firstKebab]="i === 0"
                                    (softDelete)="softSourceDelete($event)"
                                    (emitQuestionUpdate)="
                                      sourceQuestionUpdate($event)
                                    "
                                    (emitItemInfo)="kebabPreview($event)"
                                    (closeKebabOnEscape)="kebabIndex = -1"
                                    (moveQuestionUp)="moveQuestionUpDown($event, i, true)"
                                    [alternateAriaLabel]="'Options for ' + selectedQuestions.title"
                                    [id]="'questionKebab' + i"
                                    #questionKebab
                                  >
                                  </kebab-component>
                                </div>
                                <div
                                  id="droppedKebabId{{
                                    selectedQuestions.index
                                  }}"
                                  (click)="setKebabIndex(i)"
                                  *ngIf="
                                    isSectionBreak(selectedQuestions.refType)
                                  "
                                >
                                  <kebab-component
                                    [collection]="selectedQuestions"
                                    [question-source]="true"
                                    [show_kebab]="i === kebabIndex"
                                    (pinUnpinQuestion)="
                                      pinUnpinQuestion($event)
                                    "
                                    [checked-questions]="sortedQuestionsList()"
                                    [disableDelete]="true"
                                    [kebabMenuItems]="sectionBreakKebabMenu"
                                    [last_kebab]="last"
                                    [firstKebab]="i === 0"
                                    (softDelete)="softSourceDelete($event)"
                                    (emitQuestionUpdate)="
                                      sourceQuestionUpdate($event)
                                    "
                                    (emitItemInfo)="kebabPreview($event)"
                                    (closeKebabOnEscape)="kebabIndex = -1"
                                    (moveQuestionUp)="moveQuestionUpDown($event, i, true)"
                                    [alternateAriaLabel]="'Options for ' + selectedQuestions.title"
                                    [id]="'questionKebab' + i"
                                    #questionKebab
                                  >
                                  </kebab-component>
                                </div>
                              </div>
                            </div>
                            <div class="question-row">
                              <div class="question-main-content">
                                <div class="bottom-9 top-7">
                                  <span
                                    class="title-question"
                                    title="{{ selectedQuestions.title }}"
                                    [innerHtml]="
                                      selectedQuestions.title
                                        | truncate : [[truncateTitle], '...']
                                    "
                                    aria-level="3"
                                    role="heading"
                                  ></span>
                                </div>
                                <div class="right-side-question pl-0">
                                  <source-question
                                    [question-preview]="selectedQuestions.preview"
                                    [index-item]="selectedQuestions.qid + '-main'"
                                    [question-index]="i"
                                    [ref-type]="selectedQuestions.refType"
                                    [head-question]="headQuestion"
                                    [question-hidden-array]="selectedQuestionArray"
                                    (toggleQuestionHideArrayClicked)="
                                      toggleQuestionHideArray($event)
                                    "
                                    [source]="'source-select'"
                                    [question-title]="selectedQuestions.title"
                                    [expandAllObservable]="expandAllSubject.asObservable()"
                                  >
                                  </source-question>
                                </div>
                              </div>
                              <div 
                                id="droppedTablerowId{{
                                  selectedQuestions.index
                                }}"
                                class="points-div"
                              >
                                <div
                                  class="ahe-ui form-group select-point"
                                  id="question-points-parent{{
                                    selectedQuestions.index
                                  }}"
                                  *ngIf="
                                    selectedQuestions.refType === 'scalar'
                                  "
                                >
                                  <app-input
                                    label="Enter points"
                                    id="question-points{{
                                      selectedQuestions.index
                                    }}"
                                    [(ngModel)]="selectedQuestions.points"
                                    (ngModelChange)="pointsChanged($event)"
                                    type="text"
                                    (focusout)="validatePoints($event)"
                                    maxlength="7"
                                    [instruction]="pointsInstruction"
                                    [hiddenLabel]="selectedQuestions.title"
                                    [required]="true"
                                  >
                                  </app-input>
                                </div>
                              </div>
                            </div>
                            <div
                              *ngIf="selectedQuestions.refType == 'multipart'"
                              class="multipart"
                            >
                              <ng-container
                                *ngFor="
                                  let questionPart of selectedQuestions.parts;
                                  let questionId = index,
                                  first as isFirst,
                                  last as isLast,
                                "
                              >
                                <div
                                  class="container-fluid multipart-div border-div"
                                >
                                  <div class="row margin-top-10">
                                    <div class="col-auto checkbox-multipart">
                                      <app-checkbox
                                        id="droppedCheckboxLabelId{{
                                          selectedQuestions.index
                                        }}-{{ questionId }}"
                                        class="multipart-select-checkbox"
                                        [checked]="questionPart.selected"
                                        value="questionPart.qid"
                                        #checkbox
                                        (change)="
                                          OnCheckboxSelect(
                                            questionPart,
                                            $event,
                                            'part',
                                            true,
                                            selectedQuestions,
                                            questionId
                                          )
                                        "
                                        [ariaLabel]="questionPart.title"
                                      >
                                      </app-checkbox>
                                    </div>
                                    <div class="col pl-0">
                                      <div class="row w-100">
                                        <div class="title-div col pr-0">
                                          <span
                                            class="pill-btn height-20 btn-sm btn-primary"
                                          >
                                            {{ questionPart.typeDesc }}
                                          </span>
                                          <span
                                            *ngIf="questionPart.algo"
                                            class="pill-btn height-20 btn-sm btn-primary"
                                          >
                                            Algorithmic
                                          </span>
                                        </div>
                                        <div class="col-1 position-top-5 p-0">
                                          <div
                                            id="droppedTablerowId{{
                                              questionPart.questionId
                                            }}"
                                            [ngClass]="[
                                              decideBottomBorder(
                                                selectedQuestions,
                                                questionId
                                              ),
                                              decideTopBorder(
                                                selectedQuestions,
                                                questionId
                                              ),
                                              decideTopRightCorner(questionId),
                                              decideBottomRightCorner(
                                                selectedQuestions,
                                                questionId
                                              ),
                                              setBackground(),
                                              borderRight()
                                            ]"
                                            class="p-all-0 col-sm-1 col-lg-1 col-md-1 col-xl-1 question-margin"
                                          >
                                            <div
                                              #partKebab
                                              id="{{ indexCal(i, questionId) }}"
                                              (click)="
                                                setKebabIndex(
                                                  indexCal(i, questionId)
                                                )
                                              "
                                            >
                                              <kebab-component
                                                (softDelete)="
                                                  softSourceDelete($event)
                                                "
                                                [question-source]="true"
                                                [collection]="questionPart"
                                                [selectedQuestion]="
                                                  selectedQuestions
                                                "
                                                [show_kebab]="
                                                  indexCal(i, questionId) ===
                                                  kebabIndex
                                                "
                                                [disableDelete]="true"
                                                [kebabMenuItems]="
                                                  partQuestionKebabMenu
                                                "
                                                [last_kebab]="
                                                  kebabIndex ===
                                                    arrayIndex - 1 &&
                                                  kebabIndex > 2
                                                "
                                                (emitQuestionUpdate)="
                                                  sourceQuestionUpdate($event)
                                                "
                                                (emitItemInfo)="
                                                  kebabPreview($event)
                                                "
                                                (closeKebabOnEscape)="kebabIndex = -1"
                                                [alternateAriaLabel]="'Options for ' + questionPart.title"
                                                [isLastPartQuestion]="isFirst && isLast"
                                              >
                                              </kebab-component>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="question-row">
                                        <div class="question-main-content">
                                          <span
                                            class="title-question"
                                            title="{{ questionPart.title }}"
                                            [innerHtml]="
                                              questionPart.title
                                                | truncate
                                                  : [[truncateTitle], '...']
                                            "
                                            aria-level="4"
                                            role="heading"
                                          ></span>
                                          <source-question
                                            [multiple-part]="true"
                                            [question-preview]="
                                              questionPart.preview
                                            "
                                            [ref-type]="questionPart.refType"
                                            [index-item]="
                                              questionPart.qid + '-parts'
                                            "
                                            [question-index]="i"
                                            [head-question]="headQuestion"
                                            [question-hidden-array]="
                                              selectedQuestionArray
                                            "
                                            (toggleQuestionHideArrayClicked)="
                                              toggleQuestionHideArray($event)
                                            "
                                            [source]="'source-select'"
                                            [question-title]="questionPart.title"
                                            [expandAllObservable]="expandAllSubject.asObservable()"
                                          >
                                          </source-question>
                                        </div>
                                        <div
                                          id="droppedTablerowId{{
                                            questionPart.questionId
                                          }}"
                                          [ngClass]="[
                                            decideBottomBorder(
                                              selectedQuestions,
                                              questionId
                                            ),
                                            decideTopBorder(
                                              selectedQuestions,
                                              questionId
                                            ),
                                            setBackground()
                                          ]"
                                          class="p-all-0 points-padding-multipart points-div"
                                        >
                                          <div
                                            class="ahe-ui select-point"
                                            id="question-points-parent{{
                                              selectedQuestions.index
                                            }}-{{ questionId }}"
                                          >
                                            <app-input
                                              label="Enter points"
                                              id="question-points{{
                                                selectedQuestions.index
                                              }}-{{ questionId }}"
                                              [(ngModel)]="
                                                questionPart.points
                                              "
                                              (ngModelChange)="
                                                pointsChanged($event)
                                              "
                                              type="text"
                                              (focusout)="
                                                validatePoints($event)
                                              "
                                              maxlength="7"
                                              [instruction]="pointsInstruction"
                                              [hiddenLabel]="questionPart.title"
                                              [required]="true"
                                            ></app-input>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>
                            </div>
                          </div>
                          </div>
                        </li>
                    </ng-template>
                    </ul>
                  </div>
                  <div
                    class="no-ques"
                    *ngIf="selectedQuestionsListObj.length === 0 && !tempAddedQuestion && !showDropHint"
                  >
                    <strong>No Questions have been added to this test yet</strong>
                  </div>
                  <div
                    class="drop-hint"
                    *ngIf="showDropHint && selectedQuestionsListObj.length === 0"
                  >
                    Drop the question here
                  </div>
                </div>
                <div
                  id="pager-example "
                  class="border-question-pager"
                  [style]="
                    selectedQuestionsListObj.length > 0
                      ? 'visibility:visible'
                      : 'visibility:hidden'
                  "
                >
                  <app-pager
                    class="d-flex flex-column flex-md-row align-items-center justify-content-start"
                    [ariaLabel]="'Pagination for questions in Your Test Section'"
                    [length]="totalLength"
                    [pageSize]="pageSize"
                    (page)="fetchPage($event)"
                  >
                  </app-pager>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- including footer and overlay model -->
<print-preference
  *ngIf="step === 'step2'"
  [collection_id]="collectionId"
></print-preference>
<div
  class="col-md-12 col-lg-12 col-xl-12 text-center footer-{{
    step
  }} p-0 fixed-bottom"
>
  <app-footer
    [operationMode]="operationMode"
    [currentStep]="step"
    (filterEvent)="filterEvent($event)"
  ></app-footer>
</div>

<!--  Basic single button confirmation modal -->
<div class="cancel-modal remove-modal">
  <!-- basic modal -->
  <app-shared-modal
    titleText="Remove Question"
    [isOpen]="showModal"
    confirmButtonText="Yes"
    (show)="showModal = true"
    (close)="showModal = false"
    (cancel)="showModal = false"
    (confirm)="modalOkJob()"
  >
    <div class="container-fluid">
      <p>Are you sure you want to remove this question from your test?</p>
      <p class="remove-modal-container">
        <app-checkbox
          id="selectAll"
          #selectAllEdit
          (change)="setRemoveSelected($event)"
          [ariaLabelledBy]="'dont-show-message-label'"
        ></app-checkbox>
        <span id="dont-show-message-label" class="remove-text">Don't show this message again.</span>
      </p>
    </div>
  </app-shared-modal>
</div>
<modal-component
  *ngIf="alertModalShow"
  [message]="alertMessage"
  [size]="size"
  [modal-opt-option]="showModal"
  (modalOk)="modalOkJob()"
  (modalCancel)="modalCancelJob()"
></modal-component>
<preview-modal-component
  *ngIf="closeModalPopUp"
  [header]="Preview"
  [preview-data]="previewUrl"
  [question-index]="qIndex"
  (addQuestionClicked)="addQuestionClicked($event)"
  (closeModal)="closeModal($event)"
></preview-modal-component>

<!-- Section Break Question Delete From Right Panel---->

<div
  *ngIf="showSectionBreakQuestionDeleteModal"
  class="ahe-ui-alert-modal"
  id="sbDeleteModal"
  role="dialog"
  tabindex="-1"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  (keydown.escape)="checkTooltipPresent() ? null : closeSectionBreakModal()"
  aria-labelledby="deleteModalTitle"
>
  <div class="modal-overlay" id="previewModalOverlay1111">
    <div class="modal-container-new">
      <div class="modal-dialog-copy">
        <div class="modal-content">
          <div class="modal-header-new">
            <h2 id="deleteModalTitle" class="modal-title">{{ DeleteModalHeader }}</h2>
            <button
              app-button
              appTooltip="Close"
              aria-label="close dialog"
              class="close"
              data-dismiss="modal"
              type="button"
              (click)="closeSectionBreakModal()"
            >
              <span class="ahe-icon ahe-icon-close-white"></span>
            </button>
          </div>
          <div class="modal-body-new">
            <div class="question-body">
              <div class="div-cont">
                <div class="child-cont-1">
                  <i class="dpg-icon-system-alert-warning"></i>
                </div>
                <div class="child-cont-2" *ngIf="deleteMessage == 'msg1'">
                  All questions in the section break will be deleted.<br /><br />
                  Delete section break?
                </div>
                <div class="child-cont-2" *ngIf="deleteMessage == 'msg2'">
                  This section break will be deleted, because there are no
                  questions left. <br /><br />Delete Question?
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer-new">
            <app-button
              class="align-left"
              buttonText="Cancel"
              [purpose]="_buttonPurpose.Secondary"
              data-dismiss="modal"
              (click)="closeSectionBreakModal()"
              style="padding-left: 24px"
            >
            </app-button>
            <app-button
              *ngIf="secBreakRemove"
              buttonText="Yes"
              [purpose]="_buttonPurpose.Primary"
              data-dismiss="modal"
              (click)="confirmSectionBreakRemove()"
              style="padding-left: 3px"
            >
            </app-button>
            <app-button
              *ngIf="partQuestionRemove"
              buttonText="Yes"
              [purpose]="_buttonPurpose.Primary"
              data-dismiss="modal"
              (click)="confirmPartQuestionRemove()"
              style="padding-left: 3px"
            >
            </app-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="sr-only reorder-message" role="status">
  {{ reorderMessage }}
</div>
<div class="sr-only temp-add-remove-message" role="status">
  {{ tempAddRemoveMessage }}
</div>